import initials from 'initials';
import { User } from '../../api/auth';
import './UserChip.css';
import { TrashIcon } from '@heroicons/react/24/outline';

interface Props {
  user: Pick<User, 'id' | 'name' | 'email' | 'avatarColour'>;
  small?: boolean;
  onDelete?: (user: Pick<User, 'id' | 'name' | 'email' | 'avatarColour'>) => void | Promise<void>;
  compact?: boolean;
}

const UserChip: React.FC<Props> = ({ user, onDelete, small, compact }) => {
  let initialsToDisplay = initials(user.email);
  let emailToDisplay = user.email;
  user.avatarColour;
  if (user.name.split(' ').length > 1) {
    initialsToDisplay = initials(user.name);
  }

  if (user.name === 'Agent') {
    initialsToDisplay = 'AI';
    emailToDisplay = 'Agent';
  }

  return (
    <div className={`user-chip ${small ? 'user-chip--small' : ''} ${compact ? 'user-chip--compact' : ''}`}>
      <div className="user-chip__info">
        <span
          className="user-chip__initials"
          style={{
            backgroundColor: `var(--${user.avatarColour}-light)`,
            color: `var(--${user.avatarColour})`,
          }}
        >
          {initialsToDisplay.toUpperCase()}
        </span>
        {!compact && (
          <div>
            <p className="user-chip__name">{user.name}</p>
            <p className="user-chip__email" title={emailToDisplay}>
              {emailToDisplay}
            </p>
          </div>
        )}
      </div>

      {!!onDelete && (
        <button className="icon-button user-chip__delete-button" onClick={() => onDelete(user)}>
          <TrashIcon />
        </button>
      )}
    </div>
  );
};

export default UserChip;
